/* eslint-disable @next/next/no-img-element */
import { useContext } from "react"
import { ThemeContext } from "@app/contexts/theme-context"
import GradientContainer from "@app/components/gradient/gradient-container"
import Prompt from "@app/components/partners-landing-sections/prompt/index"

const SimpleWasteAccountFeatures = ['Immediate Savings', 'Flex Terms Options', 'Custom Plans',
  'Extra Service Discounts', 'Value-Added Services', 'RFP Optimization', 'Easy Sign-Up',
  'Unlimited Account Users', 'Dashboard & Mobile App', 'KPI & Data Tracking',
  'API Integrations', 'Live Support']

const TraditionalBrokerFeatures = ['Immediate Savings - Limited', 'Flex Terms Options - Limited']

const TypicalHaulerAccountFeatures = ['Immediate Savings - Limited', 'Flex Terms Options - Limited',
  'Custom Plans - Limited', 'Extra Service Discounts - Limited', 'Value-Added Services - Limited']

const TableData = [
  { feature: 'Immediate Savings', SWA: true, TB: false, THA: false, columnBg: '#F9FAFB' },
  { feature: 'Flex Terms Options', SWA: true, TB: false, THA: 'Limited', columnBg: '#FFFFFF' },
  { feature: 'Custom Plans', SWA: true, TB: 'Limited', THA: 'Limited', columnBg: '#F9FAFB' },
  { feature: 'Extra Service Discounts', SWA: true, TB: false, THA:false, columnBg: '#FFFFFF' },
  { feature: 'Value-Added Services', SWA: true, TB: 'Limited', THA: 'Limited', columnBg: '#F9FAFB' },
  { feature: 'RFP Optimization', SWA: true, TB: false, THA: false, columnBg: '#FFFFFF' },
  { feature: 'Easy Sign-Up', SWA: true, TB: false, THA: false, columnBg: '#F9FAFB' },
  { feature: 'Unlimited Account Users', SWA: true, TB: false, THA: false, columnBg: '#FFFFFF' },
  { feature: 'Dashboard & Mobile App', SWA: true, TB: false, THA: 'Limited', columnBg: '#F9FAFB' },
  { feature: 'KPI & Data Tracking', SWA: true, TB: false, THA: false, columnBg: '#FFFFFF' },
  { feature: 'API Integrations', SWA: true, TB: false, THA: false, columnBg: '#F9FAFB' },
  { feature: 'Live Support', SWA: true, TB: false, THA: 'Limited', columnBg: '#FFFFFF', isLast: true },
]

const checkSrc = "assets/svgs/platform/table-check.svg"
const checkGreySrc = "assets/svgs/platform/table-check-grey.svg"
const crossSrc = "assets/svgs/platform/table-cross.svg"

const Table = () => {
  const { isMobile } = useContext(ThemeContext) 

  const GradientList = ({ features }) => (
    <div className="border border-secondary rounded-t-2xl rounded-b-2xl">
      <GradientContainer overrideClassName="p-6 rounded-t-2xl text-center text-white text-body-xl-medium">
        SimpleWaste Account
      </GradientContainer>
      <div className="p-6">
        <p className="text-text-color-high-em text-body-lg">All Features:</p>
        <ul>
          {features.map((item) => (
            <li key={item} className="flex items-start space-x-2 my-4">
              <img src={checkSrc} alt="" />
              <p className="text-[#667085] text-body-lg">{item}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )

  const GreyList = ({ title, features }) => (
    <div className="border border-[#E5E7EB] rounded-t-2xl rounded-b-2xl">
      <div className="p-6 rounded-t-2xl text-center border-b border-[#E5E7EB] text-text-color-high-em text-body-xl-medium">
        {title}
      </div>
      <div className="p-6">
        <p className="text-text-color-mid-em text-body-lg">Only Features:</p>
        <ul>
          {features.map((item) => (
            <li key={item} className="flex items-start space-x-2 my-4">
              <img src={checkGreySrc} alt="" />
              <p className="text-[#667085] text-body-lg">{item}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )

  const MobileTable = () => (
    <div className="mt-16 px-5 sm-2:!px-10 space-y-6 pb-10">
      <GradientList features={SimpleWasteAccountFeatures} />
      <GreyList title="Traditional Broker" features={TraditionalBrokerFeatures} />
      <GreyList title="Typical Hauler Account" features={TypicalHaulerAccountFeatures} />
    </div>
  )

  const TableRow = (data) => {
    const { feature, SWA, TB, THA, columnBg, isLast } = data.data

    return (
      <div className={`flex flex-row px-6 items-center bg-[${columnBg}]`}>
        <div className="basis-1/4 mr-10">
          <p className="text-[#101828] label-md lg:label-lg xl:label-xl">{feature}</p>
        </div>
        <div className={`basis-1/4 h-20 flex flex-col justify-center items-center 
        border-x-2 border-secondary-light px-5
        ${isLast ? 'border-b-2 border-b-secondary-light rounded-b-2xl' : ''}`}>
          { SWA ? <img src={checkSrc} alt="" /> : <img src={crossSrc} alt="" /> }
        </div>
        <div className="basis-1/4 flex flex-col justify-center items-center px-5">
          {!TB ? <img src={crossSrc} alt="" /> : <p className="text-body-md lg:label-lg 
          xl:label-xl text-[#667085]">Limited</p>}
        </div>
        <div className="basis-1/4 flex flex-col justify-center items-center px-5">
          {!THA ? <img src={crossSrc} alt="" /> : <p className="text-body-md lg:label-lg 
          xl:label-xl text-[#667085]">Limited</p>}
        </div>
      </div>
    )
  }

  const DesktopTable = () => (
    <div className="mt-16 px-6 lg:px-16 xl:px-28 pb-20">
      <div className={`flex flex-row px-6 items-center`}>
        <div className="basis-1/4 mr-10" />
        <GradientContainer overrideClassName="basis-1/4 h-20 flex flex-col justify-center items-center 
        text-center rounded-t-2xl px-5">
          <p className="text-white label-md lg:label-lg xl:label-xl">
            SimpleWaste Account
          </p>
        </GradientContainer>
        <div className="basis-1/4 flex flex-col justify-center items-center text-center px-5">
          <p className="text-text-color-high-em label-md lg:label-lg xl:label-xl">
            Traditional Broker
          </p>
        </div>
        <div className="basis-1/4 flex flex-col justify-center items-center text-center px-5">
          <p className="text-text-color-high-em label-md lg:label-lg xl:label-xl">
            Typical Hauler Account
          </p>
        </div>
      </div>
      {TableData.map((item) => (
        <TableRow key={item.feature} data={item} />
      ))}
    </div>
  )

  return (
    <section className="pt-24">
      <div className="space-y-3 xs:px-4 md:px-8 lg:px-0 text-center md:text-start md:ml-6 lg:ml-16
      xl:ml-32 lg:pr-4 2xl:pr-14 3xl:pr-[200px] 4xl:pr-[440px]">
        <p className="label-lg text-secondary">PLATFORM ADVANTAGES</p>
        <h2 className="h4 sm:h3 md:h2 text-background-primary-dark">
          SimpleWaste is better than the competition.
        </h2>
      </div>
      {isMobile ? <MobileTable /> : <DesktopTable />}
      <div className="relative">
        <div className="max-w-[1440px] mx-auto">
          <Prompt offerLabel="" />
        </div>
        <div className="bg-background-low-em-dark absolute bottom-0 h-1/2 w-full"/>
      </div>
    </section>
  )
}

export default Table
